import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  getAssets(config) {
    return axiosInstance.get('/master/asset', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getAsset(config) {
    return axiosInstance.get('/master/asset/', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getAssetByName(param) {
    return axiosInstance.get(`/master/asset?findField=${param.findField}&findValue=${param.findValue}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  getAssetByType(param) {
    return axiosInstance.get(`/master/asset?findField=${param.findField}&findValue=${param.findValue}`, {
      cancelToken: getNewCancelToken(),
    });
  },
  addAsset(data) {
    return axiosInstance.post('/master/asset', data, {
      cancelToken: getNewCancelToken(),
    });
  },
  updateAsset(id, data) {
    return axiosInstance.put(`/master/asset/${id}`, data, {
      cancelToken: getNewCancelToken(),
    });
  },
  addOrUpdateAsset(id = undefined, data) {
    if (id) {
      return this.updateAsset(id, data);
    }

    return this.addAsset(data);
  },
  uploadAssetImages(id, image) {
    const formData = new FormData();
    formData.append('image', image);
    return axiosInstance.post(`/master/asset/upload/${id}`, formData, {
      cancelToken: getNewCancelToken(),
    });
  },

  deleteAsset(id) {
    return axiosInstance.delete(`/master/asset/${id}`, {
      cancelToken: getNewCancelToken(),
    });
  },
};
